export const StatusType = {
  IsPrimary: 'primary',
  IsSuccess: 'success',
  IsError: 'error',
  IsWarning: 'warning',
  IsPending: 'pending',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type StatusType = (typeof StatusType)[keyof typeof StatusType];
